import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import { getAllSubscriptionByRole } from "../../../services/admin/adminAllApiFn";
import { getCurrentSubscription } from "../../../services/common/CommonApiFn";
import { handleOpenSnackBar } from "../../../utils";
import PlansCard from "./PlansCard";

function AllPlans() {
  const [allSubscription, setAllSubscription] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    if (userData) {
      fetchAllData();
    }
  }, [userData]);

  const fetchAllData = async () => {
    try {
      setIsLoading(true);

      const [subscriptionsResponse, currentSubscriptionResponse] =
        await Promise.all([
          getAllSubscriptionByRole("worker"),
          getCurrentSubscription(userData?._id, "worker"),
        ]);

      // Handle the subscriptions response
      if (subscriptionsResponse?.data?.status === "success") {
        setAllSubscription(subscriptionsResponse?.data?.data);
      } else {
        handleOpenSnackBar("error", subscriptionsResponse?.data?.message);
      }

      // Handle the current subscription response
      if (currentSubscriptionResponse?.data?.status === "success") {
        setCurrentSubscription(currentSubscriptionResponse?.data?.data);
      } else {
        handleOpenSnackBar("error", currentSubscriptionResponse?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("allPlans")}
        secondaryHeading={t("packageEditNote")}
      >
        <PlansCard
          data={allSubscription}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          currentSubscription={currentSubscription}
        />
      </AppContainer>
    </>
  );
}

export default AllPlans;
